
export class DataLayer {
    browserGlobals = {
        windowRef() {
            return window;
        },
        documentRef() {
            return document;
        }
    };

    constructor() { }

    getDataLayer() {
        const window = this.browserGlobals.windowRef();
        window['dataLayer'] = window['dataLayer'] || [];
        return window['dataLayer'];
    }

    pushOnDataLayer(obj) {
        const dataLayer = this.getDataLayer();
        dataLayer.push(obj);

        // console.log(this.getDataLayer());
    }

    //Função para formatar um string conforme o padrão da Zoly desde 2017
    sanitizeText(str) {
        if (str) {
            str = str
                .trim()
                .toLowerCase()
                .replace(/\s+/g, ' ')
                .replace(/\s+/g, '-')
                .replace(/[,]/g, '-')
                .replace('(', '-')
                .replace(')', '-')
                .replace(/[áàâãåäæª]/g, 'a')
                .replace(/[éèêë?€]/g, 'e')
                .replace(/[íìîï]/g, 'i')
                .replace(/[óòôõöøº]/g, 'o')
                .replace(/[úùûü]/g, 'u')
                .replace(/[ç¢©]/g, 'c');
            return str;
        } else {
            return str;
        }
    }
}